import { FC, PropsWithChildren, createContext, useEffect, useState } from "react";
import { Auth, User } from "../@types/Auth";
import { RouteType } from "../@types/RouteType";
import InternationalDealerAdminRoutes from "../routes/InternationalDealerAdminRoutes";
import DealerAdminRoutes from "../routes/DealerAdminRoutes";
import InternationalDealerSalesRoutes from "../routes/InternationalDealerSalesRoutes";
import DealerSalesRoutes from "../routes/DealerSalesRoutes";
import DealerServiceRoutes from "../routes/DealerServiceRoutes";
import DealerSupportRoutes from "../routes/DealerSupportRoutes";
import AdminPortalRoutes from "../routes/AdminPortalRoutes";

const AuthContext = createContext<Auth | undefined>(undefined);

export const AuthProvider: FC<PropsWithChildren> = ({ children }) => {
    const [token, setToken] = useState<string | undefined>(undefined);
    const [user, setUser] = useState<User | undefined>(undefined);
    const [userAuthorizedRoutes, setUserAuthorizedRoutes] = useState<RouteType[]>([]);

    const logout = () => {
        setUser(undefined);
        setToken(undefined);
        localStorage.removeItem('MJDP-ath');
    }

    useEffect(() => {
        try {
            if (token) {
                localStorage.setItem('MJDP-ath', `${token}`);
            }
        } catch (error) {
            console.error(error);
        }
    }, [token]);


    useEffect(() => {
        if (user) {
            switch (user?.attributes?.type) {
                case 'dealer-admin':
                    if (user?.companyAttributes?.international) {
                        setUserAuthorizedRoutes(InternationalDealerAdminRoutes);
                    } else {
                        setUserAuthorizedRoutes(DealerAdminRoutes);
                    }
                    break;
                case 'dealer-sales':
                    if (user?.companyAttributes?.international) {
                        setUserAuthorizedRoutes(InternationalDealerSalesRoutes);
                    } else {
                        setUserAuthorizedRoutes(DealerSalesRoutes);
                    }
                    break;
                case 'dealer-service':
                    setUserAuthorizedRoutes(DealerServiceRoutes);
                    break;
                case 'dealer-support':
                    setUserAuthorizedRoutes(DealerSupportRoutes);
                    break;
                case 'admin':
                    setUserAuthorizedRoutes(AdminPortalRoutes);
                    break;
                default:
                    setUserAuthorizedRoutes(DealerSalesRoutes);
                    break;
            }
        }
    }, [user, setUserAuthorizedRoutes]);

    return (
        <AuthContext.Provider
            value={{
                token,
                setToken,
                user,
                setUser,
                logout,
                userAuthorizedRoutes,
                setUserAuthorizedRoutes
            }}>
            {children}
        </AuthContext.Provider>
    )
}

export default AuthContext;